import React, { useEffect, useRef, useState } from 'react';

export default function ScrollRevealText({ children, className = '', as: Tag = 'p', style: externalStyle }) {
  const ref = useRef();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleScroll = () => {
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // Start revealing when element enters bottom 80% of viewport
      // Fully revealed when at 40% from top
      const start = windowHeight * 0.85;
      const end = windowHeight * 0.35;
      const current = rect.top;

      if (current >= start) {
        setProgress(0);
      } else if (current <= end) {
        setProgress(1);
      } else {
        setProgress((start - current) / (start - end));
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Interpolate color from gray to dark
  const r = Math.round(139 + (13 - 139) * progress);
  const g = Math.round(147 + (15 - 147) * progress);
  const b = Math.round(163 + (26 - 163) * progress);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        ...externalStyle,
        color: `rgb(${r}, ${g}, ${b})`,
        transition: 'color 0.05s linear',
      }}
    >
      {children}
    </Tag>
  );
}
